import { render, staticRenderFns } from "./EventsSingle.vue?vue&type=template&id=7cbe8423&"
import script from "./EventsSingle.vue?vue&type=script&lang=js&"
export * from "./EventsSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports